// Static option sets for the Question Bank module.
// Nothing here encodes an actual bank / unit / lecture name - those are
// always admin-authored and come from the API.

export const STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const STATUS_OPTIONS = [
  { value: STATUS.ACTIVE, label: "Active" },
  { value: STATUS.INACTIVE, label: "Inactive" },
];

// Question types. Adding a new type here is the only change needed for the
// list/filter UIs; the editor reads the flags below to decide what to render.
export const QUESTION_TYPES = {
  MCQ_SINGLE: "mcq_single",
  MCQ_MULTIPLE: "mcq_multiple",
  TRUE_FALSE: "true_false",
  SHORT_ANSWER: "short_answer",
  ESSAY: "essay",
};

export const QUESTION_TYPE_META = {
  [QUESTION_TYPES.MCQ_SINGLE]: {
    label: "Multiple Choice (single answer)",
    hasOptions: true,
    multiCorrect: false,
    minOptions: 2,
    fixedOptions: null,
  },
  [QUESTION_TYPES.MCQ_MULTIPLE]: {
    label: "Multiple Choice (multiple answers)",
    hasOptions: true,
    multiCorrect: true,
    minOptions: 2,
    fixedOptions: null,
  },
  [QUESTION_TYPES.TRUE_FALSE]: {
    label: "True / False",
    hasOptions: true,
    multiCorrect: false,
    minOptions: 2,
    fixedOptions: ["True", "False"],
  },
  [QUESTION_TYPES.SHORT_ANSWER]: {
    label: "Short Answer",
    hasOptions: false,
    multiCorrect: false,
    minOptions: 0,
    fixedOptions: null,
  },
  [QUESTION_TYPES.ESSAY]: {
    label: "Essay",
    hasOptions: false,
    multiCorrect: false,
    minOptions: 0,
    fixedOptions: null,
  },
};

// Types the admin can pick from. The bank is MCQ-only for now; the other
// types stay defined above (and supported by the backend) so enabling one
// later is a one-line change here.
export const ENABLED_QUESTION_TYPES = [QUESTION_TYPES.MCQ_SINGLE];

// With a single enabled type the editors hide the type picker entirely.
export const SHOW_QUESTION_TYPE_PICKER = ENABLED_QUESTION_TYPES.length > 1;

export const QUESTION_TYPE_OPTIONS = ENABLED_QUESTION_TYPES.map((value) => ({
  value,
  label: QUESTION_TYPE_META[value].label,
}));

export const typeMeta = (type) =>
  QUESTION_TYPE_META[type] || QUESTION_TYPE_META[QUESTION_TYPES.MCQ_SINGLE];

export const DIFFICULTY_OPTIONS = [
  { value: "easy", label: "Easy" },
  { value: "medium", label: "Medium" },
  { value: "hard", label: "Hard" },
];

// Course association modes.
export const ASSIGNMENT_MODES = {
  FULL_BANK: "FULL_BANK",
  SELECTED_UNITS: "SELECTED_UNITS",
};

export const ASSIGNMENT_MODE_LABELS = {
  [ASSIGNMENT_MODES.FULL_BANK]: "Entire Question Bank",
  [ASSIGNMENT_MODES.SELECTED_UNITS]: "Selected Units",
};

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
